import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import _ from '@sparta.global.vendors/lodash';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { is } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { htmlEscaper } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n<div id=\"campaign\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignMap") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"pageID") : stack1),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":8,"column":37},"end":{"line":8,"column":69}}}),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":8,"column":29},"end":{"line":8,"column":72}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/campaign-properties-cc-module",
  "version": "4.0.0",
  "id": "campaignPropertiesCcModule",
  "containerID": "creditCardsCampaignPropertiesCcModule",
  "moduleName": "credit-cards-campaign-properties-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "campaign-properties-cc-module",
  "data": {
    "init": "campaignPropertiesCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "title-property-large",
    "type": "string",
    "values": ["BYAPAGE_HEADLINE_01_TEXT"],
    "default": "BYAPAGE_HEADLINE_01_TEXT",
    "description": ""
  }, {
    "name": "title-property-medium",
    "type": "string",
    "values": ["BYAPAGE_HEADLINE_01_TEXT"],
    "default": "BYAPAGE_HEADLINE_01_TEXT",
    "description": ""
  }, {
    "name": "title-property-small",
    "type": "string",
    "values": ["BYAPAGE_HEADLINE_01_TEXT"],
    "default": "BYAPAGE_HEADLINE_01_TEXT",
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        is,
        json,
        htmlEscaper
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    is,
    json,
    htmlEscaper
  },
  "dependencies": {
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-global-functions-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-global-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global bactm_addProducts bactm_productView */

/* eslint-disable camelcase, no-console, no-param-reassign */

/*
 * campaign-properties-cc-module
 * module_js_id: campaignPropertiesCCModule
 *
 * Copyright (c) 2017-12-4 removed
 */

/*
 * List of modules are are rendered using campaign properties
 */
const productDetailsModules = ['credit-cards-product-engagement-cc-module', 'credit-cards-product-sticky-navbar-cc-module', 'credit-cards-card-details-cc-module', 'credit-cards-interest-rates-fees-cc-module', 'credit-cards-rewards-cc-module', 'credit-cards-rewards-calc-cc-module', 'credit-cards-network-benefits-cc-module', 'credit-cards-security-benefits-cc-module', 'credit-cards-apply-now-cc-module'];

/**
 * @export
 * @class campaignPropertiesCcModuleJS
 * @extends {Module}
 */
class campaignPropertiesCcModuleJS extends Module {
  /**
   * Creates an instance of campaignPropertiesCcModuleJS.
   * @param {object} options - options object
   * @param {object} context - context object
   * @memberof campaignPropertiesCcModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // List of rendered product detail modules
    this.renderedProductDetailsModules = [];

    // Determine campaign associated with this page
    this.campaignId = spartaGlobalFunctions.getUrlParam('campaign');
    if (this.campaignId) {
      const campaignInfo = this.campaignId.split('~');
      this.settings.campaign = {
        campaignID: campaignInfo[0],
        poCode: campaignInfo[1],
        locale: this.Store.getData('lang').replace(/(\w{2})(?:-us)?/gi, '$1_US')
      };
    } else {
      try {
        this.settings.campaign = JSON.parse(this.settings.target.querySelector('#campaign').dataset.jcr);

        // Construct full campaign id string for zip code gating modal
        const {
          campaignID,
          locale,
          poCode
        } = this.settings.campaign;
        this.campaignId = `${campaignID}~${poCode}~${locale}`;
      } catch (e) {
        this.debug(`Unable to parse response. Error: ${e}`);
      }
    }
    this.settings.calcDisplaySwitch = 'REWARDS_CALCULATOR_TYPE';
  }

  /**
   * Initialize the campaignPropertiesCcModule
   *
   * @memberof campaignPropertiesCcModuleJS
   * @returns {void}
   */
  init() {
    this.expectedProductDetailsModules = this.getExpectedProductDetailsModules();
    this.Store.addData('campaign', this.settings.campaign);
    this.settings.locationChange = false;

    // Fetch campaign data
    const queryString = {
      ...this.settings.campaign,
      failquiet: true
    };
    creditCardUtility.productProperties(queryString).then(result => {
      if (result && result.code && result.code === '500') {
        // Something messed up on the backend, treat as a failure
        this.handleLoadFailure();
        console.error(result.message);
        return;
      }
      this.campaignProperties = result;
      this.adaDaggerFix(result);
      this.Store.addData('campaignProperties', result);

      // cadets switch to turn off the display the calculator section
      const calcDisplaySwitch = this.Store.getData('campaignProperties')[this.settings.calcDisplaySwitch];
      if (calcDisplaySwitch === undefined || calcDisplaySwitch === '' || calcDisplaySwitch === 'OFF') {
        const calcSection = document.body.querySelector('.calculator-section');
        const calcGraphSection = document.body.querySelector('calculator-bar-graph-section');
        if (calcSection) calcSection.style.display = 'none';
        if (calcGraphSection) calcGraphSection.style.display = 'none';
      }
      if (typeof bactm_addProducts === 'function') {
        this.cmSend(this.Store.getData('campaignProperties'));
      } else {
        this.debug('Coremetrics unavailable. Please confirm tag manager and digital data object (paramaters.ddo) are setup properly for this page.');
      }
    }).catch(error => {
      this.handleLoadFailure();
      console.error(error); // eventually use the core debug utility for this
    });
    this.Events.sub(creditCardUtility.EVENTS.productDetailsRendered, this.handleProductDetailsRendered.bind(this), true);
    document.addEventListener('apsFailed.campaignPropertiesCcModuleJS', e => {
      // Only trigger this event a single time
      // Used to be a single-line IF() statement.
      // Single-line IF() statements get me triggered
      if (e.currentTarget.dataset.triggered) {
        return;
      }
      e.currentTarget.dataset.triggered = true;
      const msg = document.createElement('div');
      msg.innerHTML = document.getElementById('errorMsgGeneric').outerHTML;
      const mainLoader = document.querySelector('.main-section .loader');
      mainLoader.style.display = 'none';
      mainLoader.parentNode.insertBefore(msg, mainLoader);
    });
  }

  /**
   * Hack to add ada attributes to dagger superscripts from PCM
   * They refuse to change it on the backend, so we're
   * forced to make this swap on the frontend.
   *
   * @param {*} campaign - campaign object to replace values within.
   * @memberof campaignPropertiesCcModuleJS
   * @returns {void}
   */
  adaDaggerFix(campaign) {
    Object.keys(campaign).forEach(key => {
      if (typeof campaign[key] === 'string') {
        campaign[key] = campaign[key].replace(/fee†/g, 'fee<sup aria-hidden=\'true\'>†</sup>');
        campaign[key] = campaign[key].replace(/<sup>&dagger;<\/sup>/g, '<sup aria-hidden=\'true\'>&dagger;</sup>');
        campaign[key] = campaign[key].replace(/<sup>†<\/sup>/g, '<sup aria-hidden=\'true\'>†</sup>');
        campaign[key] = campaign[key].replace(/<sup>† <\/sup>/g, '<sup aria-hidden=\'true\'>† </sup>');
        campaign[key] = campaign[key].replace(/<sup><span style='font-size: small;'>†<\/span><\/sup>/g, '<sup aria-hidden=\'true\'><span style=\'font-size: small;\'>†</span></sup>');
      }
    });
  }

  /**
   * Debug wrapper
   * @param {*} msg - message to log to console
   * @memberof campaignPropertiesCcModuleJS
   * @returns {void}
   */
  debug(msg) {
    if (window.console && this.settings.debug) {
      console.log(msg);
    }
  }

  /**
   * CoreMetrics trigger function
   * @param {*} campaignData - Object container for campaign
   * @memberof campaignPropertiesCcModuleJS
   * @returns {void}
   */
  cmSend(campaignData) {
    const prodID = `${campaignData.GROUP_CODE} ${campaignData.SOURCE_CODE}`;
    bactm_addProducts(prodID, campaignData.EPRODUCT_NAME, this.settings.prodCategoryID);
    if (typeof bactm_productView === 'function') {
      bactm_productView();
    }
  }

  /**
   * Handle the case when PCM fails to respond.
   * Pub failure event, and hide page content.
   * @returns {void}
   */
  handleLoadFailure() {
    this.Events.pub(creditCardUtility.EVENTS.loaderHide);
    if (window.location.href.indexOf('/products/') !== -1) {
      // On a products page, display error message with link back to CC homepage
      this.Events.pub(creditCardUtility.EVENTS.errorShowGeneric, {});
      // Hide everything but head-row and foot-row
      const pageSections = Array.from(document.querySelectorAll('section'));
      pageSections.forEach(section => {
        const tempSection = section;
        tempSection.style.display = 'none';
        if (tempSection.classList.contains('head-row') || tempSection.classList.contains('foot-row')) {
          tempSection.style.display = 'inherit';
        }
      });
      // Hide productEngagement section specifically - hides grey bar
      document.getElementById('productEngagementCcModule').style.display = 'none';
    } else {
      // On a different page, display error message with link back to main homepage
      this.Events.pub(creditCardUtility.EVENTS.errorShowHome, {});
    }
  }

  /**
   * Returns list of expected product details modules
   * @returns {Array} expected modules
   */
  getExpectedProductDetailsModules() {
    const querySelectors = [];
    productDetailsModules.forEach(moduleName => {
      querySelectors.push(`[data-module='${moduleName}']`);
    });
    const modules = [...document.querySelectorAll(querySelectors.join(','))];
    const expected = [];
    modules.forEach(module => {
      expected.push(module.dataset.module);
    });
    return expected;
  }

  /**
   * Handles product details sub event, updates semaphore for each module rendered
   * @param {Object} eventData sub data
   * @returns {void}
   */
  handleProductDetailsRendered(eventData) {
    const {
      data
    } = eventData;
    const {
      module
    } = data;
    if (!module) return;
    if (!this.renderedProductDetailsModules.includes(module)) {
      this.renderedProductDetailsModules.push(module);
    }
    if (_.isEqual(this.expectedProductDetailsModules, this.renderedProductDetailsModules)) {
      creditCardUtility.parseFootnotes(this.campaignProperties);
      spartaStickyUtility.recalcStickyEls();
      this.handleHashOveride(this.getHashAnchorId());
      this.Events.pub(creditCardUtility.EVENTS.productDetailsReady, {
        campaignId: this.campaignId
      });
      this.Events.pub(creditCardUtility.EVENTS.loaderHide);
    }
  }

  /**
   * The default anchor link for headlineCcalcModule was being overlapped by the title
   * and sticky nav. This function checks if the hash is '#headlineCcalcModule'
   * and works with handleHashOveride();
   * @returns {string} or {boolean}
   */
  getHashAnchorId() {
    return (window.location.hash || '').substr(1);
  }

  /**
   * If hashAnchorID is not false, use it to get the target location y-position
   * Then, calculate the title and sticky height
   * Use title and sticky height to offset scroll distance so target element is not overlapped.
   *
   * @param {string} hashAnchorId hash value
   * @returns {undefined}
   */
  handleHashOveride(hashAnchorId) {
    if (!hashAnchorId) {
      return;
    }
    window.location.hash = '';
    window.location.hash = `#${hashAnchorId}`;
  }
}
registerModuleClass({
  moduleClass: campaignPropertiesCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { campaignPropertiesCcModuleJS as default, moduleConfig };
